export const environment = {
    production: false,
    backend_url: "https://appdev.talonic.ai/backend",
    websocket_url: "wss://appdev.talonic.ai",
    image_url: "https://appdev.talonic.ai/uploads/image",
    STRIPE_SECRET_TEST_KEY: 'sk_test_51O0MVzK09GQBKaWqYfHk0FUmDo1XwcvDHOuXxOzpcdVfVakfYnAE3g26dAjSLMhx4Rej04gO2Ch0f0pGGeRjAzMa00rzIj7JcY',
    STRIPE_PUBLISH_TEST_KEY: 'pk_test_51O0MVzK09GQBKaWq1yDqLu9DiVh1Pn3mb8XLYGoaAKuXnePJDgBgbpfskznsGdOuYA3r7ESP5IpTXF77yiwNiUOA00YJigSAaD',
    cognito: {
        userPoolId: 'eu-north-1_bWjzqzjkm',
        userPoolWebClientId: '2noba89b9rbn2nl0qgnbnok0bq',
    },
    aws_cognito_region: "eu-north-1",
    aws_user_pools_id: "eu-north-1_bWjzqzjkm",
    aws_user_pools_web_client_id: "2noba89b9rbn2nl0qgnbnok0bq",
    aws_cognito_identity_pool_id: "eu-north-1:6541617a-eb15-47c2-80ce-e6b5f69e1962"
};